import type { ConfirmDialogProps } from 'primereact/confirmdialog';
import type { ReactNode } from 'react';
import type { ConfirmDialogState } from './confirmation.types';

const initialState = {
	isVisible: false,
	message: '',
	props: {},
};

export const createConfirmDialogStore = (
	set: (
		state:
			| Partial<ConfirmDialogState>
			| ((state: ConfirmDialogState) => Partial<ConfirmDialogState>),
	) => void,
) => ({
	...initialState,
	resetState: () => set(initialState),
	setIsHydrated: (isHydrated: boolean) => set({ isHydrated }),
	show: (
		message: ReactNode | (() => ReactNode),
		props?: Partial<ConfirmDialogProps>,
	) =>
		set({
			isVisible: true,
			message,
			props,
		}),
	hide: () => set(initialState),
});
